import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { AppConstant } from './app.constant';

@Injectable({
  providedIn: 'root'
})
export class AuthguardService implements CanActivate {

  constructor(
    private router: Router
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    let url: string = state.url;
    if (localStorage.getItem(AppConstant.localStorage.IsCLLogin) == "0") {
      if (localStorage.getItem(AppConstant.localStorage.token) == null || localStorage.getItem(AppConstant.localStorage.token) == 'token' && localStorage.getItem(AppConstant.localStorage.token) == '') {
        this.router.navigateByUrl("");
        return false;
      }
    } else if (localStorage.getItem(AppConstant.localStorage.IsCLLogin) == null || localStorage.getItem(AppConstant.localStorage.IsCLLogin) == undefined) {
      this.router.navigateByUrl("");
      return false;
    }
    return true;
  }
}
